<div class="icons-section">
  <span (click)="unlockClick()" *ngIf="showUnlockButton" class="pointer-cursor">
    <i
      class="pi pi-times"
      [ngClass]="[isLocked === false ? 'unlock-icon-style' : '', areButtonsDisabled ? 'default-cursor' : '']"
      [pTooltip]="showUnlockTooltip ? ('review-section.review-not-ok-tooltip' | translate) : null"
      [tooltipPosition]="showUnlockTooltip ? 'bottom' : null"
      tabindex="0"
      appEnterClick></i>
  </span>
  <span (click)="lockClick()" *ngIf="showLockButton" class="pointer-cursor">
    <i
      class="pi pi-check"
      [ngClass]="[isLocked === true ? 'lock-icon-style' : '', areButtonsDisabled ? 'default-cursor' : '']"
      [pTooltip]="showLockTooltip ? ('review-section.review-ok-tooltip' | translate) : null"
      [tooltipPosition]="showLockTooltip ? 'bottom' : null"
      tabindex="0"
      appEnterClick></i>
  </span>
</div>
